
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 8","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M10 1.212a.486.486 0 01-.126.347L4.117 7.297c-.116.121-.198.168-.36.168-.16 0-.251-.046-.367-.168L.13 4.056a.492.492 0 01-.127-.283c-.014-.158.02-.283.102-.377l.808-.788a.421.421 0 01.39-.093c.095.028.145.028.244.12l2.21 2.217L8.482.119C8.55.057 8.654.018 8.798 0c.13 0 .227.04.294.119l.803.778a.47.47 0 01.105.315z","opacity":".5"}}),_c('path',{attrs:{"d":"M14 1.212a.486.486 0 01-.126.347L8.117 7.297c-.116.121-.198.168-.36.168-.16 0-.251-.046-.367-.168L4.13 4.056a.492.492 0 01-.127-.283c-.014-.158.02-.283.102-.377l.808-.788a.421.421 0 01.39-.093c.095.028.145.028.244.12l2.21 2.217L12.482.119c.068-.062.173-.101.317-.119.13 0 .227.04.294.119l.803.778a.47.47 0 01.105.315z"}})])])
          )
        }
      }
    